export class ApiError extends Error {
  constructor(status, message) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}

export default async function apiFetch(url, opts = {}) {
  const token = localStorage.getItem("token");

  const headers = new Headers(opts.headers || {});
  if (token) headers.set("Authorization", `Bearer ${token}`);

  // ВАЖНО: если FormData — Content-Type не трогаем
  let body = opts.body;
  const isFormData = typeof FormData !== "undefined" && body instanceof FormData;

  // если кто-то захочет передавать объект как JSON
  if (body && !isFormData && typeof body === "object" && !(body instanceof Blob)) {
    headers.set("Content-Type", "application/json");
    body = JSON.stringify(body);
  }

  const res = await fetch(url, { ...opts, headers, body });

  if (res.status === 401) throw new ApiError(401, "UNAUTHORIZED");
  if (res.status === 403) throw new ApiError(403, "FORBIDDEN");

  return res;
}
